<template>
  <PageWrap>
    <Error404 :error="{ statusCode: 404 }" v-if="error" />

    <template v-else>
      <HeadSeo :data="data" />
      <HeaderOther :h1="data?.title" />
      <main>
        <UiBreadCrumbs
          :data="[
            {
              title: 'Услуги',
              path: '/service',
            },
            {
              title: data?.menu_title,
            },
          ]"
        />
        <BlockPageText :html="data?.text" />
        <BlockGallery
          :name="`service-${data.id}`"
          :data="data?.gallery"
          :h2="`${data?.menu_title}: фото/видео`"
          v-if="data?.gallery"
        />
        <BlockZakazBtn />
        <BlockWhyWe />
        <BlockZakaz />
        <BlockAchievements />
        <BlockContact />
      </main>
    </template>
    <BlockFoot />
  </PageWrap>
</template>

<script setup>
const { url } = useRoute().params;
const { data, error } = await useFetch(`/api/service.post?url=${url}`);
if (error.value) {
  const event = useRequestEvent();
  setResponseStatus(event, 404, "Page Not Found");
}
</script>
